var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{attrs:{"outline":"","round":"","dense":"","size":"12px","color":"info","icon":"trash-outline"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.del.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }